// Feedback service for collecting user feedback
import { db } from '../firebase';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';

// Collection for feedback
const FEEDBACK_COLLECTION = 'feedback';

export const submitFeedback = async (feedbackData) => {
  try {
    const feedbackWithMeta = {
      ...feedbackData,
      submittedAt: serverTimestamp(),
      userAgent: navigator.userAgent.substring(0, 100),
      url: window.location.href,
      timestamp: Date.now(),
    };

    console.log('Submitting feedback:', feedbackWithMeta);

    const docRef = await addDoc(collection(db, FEEDBACK_COLLECTION), feedbackWithMeta);

    console.log('Feedback submitted with ID:', docRef.id);
    return { id: docRef.id, success: true };
  } catch (error) {
    console.error('Error submitting feedback:', error);
    throw error;
  }
};
